import "./projects/app/src/polyfills.ts";(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
